var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-card",
    { attrs: { title: "" } },
    [
      _c("schedule-status", {
        staticClass: "activitylog-tab__status",
        attrs: {
          tinted: "",
          status: _vm.mappedActivity.status,
          "item-id": _vm.mappedActivity.job_id,
        },
      }),
      _vm._v(" "),
      _c("mds-list-group", [
        _c(
          "div",
          { staticClass: "activitylog-tab__content" },
          [
            _c("mds-icon", { attrs: { name: "play-circle", size: "small" } }),
            _vm._v(" "),
            _c("mds-list-group-item", {
              staticClass: "activitylog-tab__title",
              attrs: {
                text: _vm.translate(
                  "flyover.schedules.activityLog.card.startTime.label"
                ),
                microcopy: _vm.displayDate(
                  _vm.mappedActivity.start_time,
                  _vm.TIMES.startTime
                ),
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "activitylog-tab__content" },
          [
            _c("mds-icon", { attrs: { name: "stop-circle", size: "small" } }),
            _vm._v(" "),
            _c("mds-list-group-item", {
              staticClass: "activitylog-tab__title",
              attrs: {
                text: _vm.translate(
                  "flyover.schedules.activityLog.card.endTime.label"
                ),
                microcopy: _vm.displayDate(
                  _vm.mappedActivity.end_time,
                  _vm.TIMES.endTime
                ),
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "activitylog-tab__content" },
          [
            _c("mds-icon", { attrs: { name: "info-circle", size: "small" } }),
            _vm._v(" "),
            _c("mds-list-group-item", {
              staticClass: "activitylog-tab__title",
              attrs: {
                text: _vm.translate(
                  "flyover.schedules.activityLog.card.jobId.label"
                ),
                microcopy: _vm.mappedActivity.job_id,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }